module.exports = __webpack_public_path__ + "assets/cookiebot.654d4654.svg";